import Ctor from './ctor'

const PREFIXCLS = 'popover'

export default {
  name: 'poptip',
  bind (el, binding, vnode, oldVnode) {
    let ctor = new Ctor()
    let options = Object.assign({
      prefixCls: PREFIXCLS,
      trigger: 'click',
      title: '',
      content: '',
      width: '',
      confirm: false,
      localeOkText: '确定',
      localeCancelText: '取消',
      placement: 'bottom',
      visible: false
    }, binding.value)
    ctor.el = el
    ctor.onPopperShow = binding.value.onPopperShow
    ctor.onPopperHide = binding.value.onPopperHide
    ctor.onPopperConfirm = binding.value.onPopperConfirm
    ctor.onPopperCancel = binding.value.onPopperCancel
    switch (options.trigger) {
      case 'click':
        el.addEventListener('click', (e) => {
          ctor.setVisible(e, options, binding, el, 1)
        })
        break
      case 'focus':
        el.addEventListener('focus', (e) => {
          ctor.setVisible(e, options, binding, el, 1)
        })
        el.addEventListener('blur', (e) => {
          ctor.setVisible(e, options, binding, el, 0)
        })
        break
      case 'hover':
        el.addEventListener('mouseenter', (e) => {
          ctor.setVisible(e, options, binding, el, 1)
        })
        el.addEventListener('mouseleave', (e) => {
          ctor.setVisible(e, options, binding, el, 0)
        })
        break
    }
    Object.keys(options).map(key => {
      if (key !== 'onPopperShow' && key !== 'onPopperHide' && key !== 'onPopperConfirm' && key !== 'onPopperCancel') {
        switch (Object.prototype.toString.call(options[key])) {
          case '[object String]':
          case '[object Number]':
            el.dataset[key] = options[key]
            break
          case '[object Boolean]':
            el.dataset[key] = options[key] ? 1 : 0
            break
          default:
            el.dataset[key] = options[key] ? options[key] : 0
            break
        }
      }
    })
    binding.value.ctor = ctor
  },
  inserted (el, binding, vnode, oldVnode) {
    let ctor = binding.value.ctor
    let options = el.dataset
    let popperOpt = {
      gpuAcceleration: false,
      boundariesElement: 'viewport',
      forceAbsolute: true
    }
    ctor.createPopper(options, binding, popperOpt, el)
    ctor.clickOutSide(el, ctor.popperEl, () => {
      if (parseInt(options.conform)) {
        el.dataset.visible = 0
        ctor.setCickOutSide(el, binding)
        return true
      }
      if (options.trigger !== 'click') {
        return false
      }
      el.dataset.visible = 0
      ctor.setCickOutSide(el, binding)
    })
  },
  update (el, binding, vnode, oldVnode) {
    let ctor = binding.value.ctor
    // let options = el.dataset
    // let popperOpt = {
    //   gpuAcceleration: false,
    //   boundariesElement: 'viewport',
    //   forceAbsolute: true
    // }
    // ctor.popperJS ? ctor.destoryPopper() : ctor.createPopper(options, binding, popperOpt, el)
    ctor.updatePopperOps(el, binding)
  },
  unbind (el, binding, vnode, oldVnode) {
    let ctor = binding.value.ctor
    const popper = ctor.popperEl
    if (ctor.popperJS && popper) {
      if (popper.parentNode) {
        popper.parentNode.removeChild(popper)
      }
      ctor.popperJS.destroy()
      ctor.popperJS = null
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/poptip/d-poptip.js